import { ChangeEvent } from "react";
import CommonModal from "../../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { selectTeamMembersAttendanceList } from "../../redux/selector/teamMembersAttendanceListSelector";
import TeamMembersAttendanceBulkApprovedForm from "../forms/TeamMembersAttendanceBulkApprovedForm";
import { CheckboxAttendanceRequest } from "../../types";

export interface ITeamMembersAttenanceBulkApproveModalProps {
  isOpen: boolean;
  selectAllAttendanceRequest: boolean;
  allTeamAttendanceRequests: CheckboxAttendanceRequest[];
  checkboxTeamAttendanceRequest: CheckboxAttendanceRequest[];
  closeModal: () => void;
  searchEmployeeAttendanceRequest: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectAllAttendanceRequest: (e: ChangeEvent<HTMLInputElement>) => void;
  sortEmployeeAttendanceRequestList: (
    a: CheckboxAttendanceRequest,
    b: CheckboxAttendanceRequest
  ) => number;
  onCheckboxAttendanceRequest: (
    e: ChangeEvent<HTMLInputElement>,
    item: CheckboxAttendanceRequest
  ) => void;
  onBulkAttendance: (action: "approved" | "rejected") => void;
}

const TeamMembersAttendanceBulkApproveModal = ({
  isOpen,
  closeModal,
  allTeamAttendanceRequests,
  checkboxTeamAttendanceRequest,
  onBulkAttendance,
  onCheckboxAttendanceRequest,
  onSelectAllAttendanceRequest,
  searchEmployeeAttendanceRequest,
  selectAllAttendanceRequest,
  sortEmployeeAttendanceRequestList,
}: ITeamMembersAttenanceBulkApproveModalProps) => {
  const teamMembersAttendanceList = useAppSelector(
    selectTeamMembersAttendanceList
  );
  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title={`Team Attendance Request List : ${teamMembersAttendanceList?.data?.length}`}
      modalBodyClassName="px-2"
      centered
      toggle={closeModal}
      isOpen={isOpen}
      showFooter={false}
    >
      <TeamMembersAttendanceBulkApprovedForm
        allTeamAttendanceRequests={allTeamAttendanceRequests}
        checkboxTeamAttendanceRequest={checkboxTeamAttendanceRequest}
        onBulkAttendance={onBulkAttendance}
        onCheckboxAttendanceRequest={onCheckboxAttendanceRequest}
        onSelectAllAttendanceRequest={onSelectAllAttendanceRequest}
        searchEmployeeAttendanceRequest={searchEmployeeAttendanceRequest}
        selectAllAttendanceRequest={selectAllAttendanceRequest}
        sortEmployeeAttendanceRequestList={sortEmployeeAttendanceRequestList}
      />
    </CommonModal>
  );
};

export default TeamMembersAttendanceBulkApproveModal;
